/**
 * Reserva Belegungsplan
 */

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var moment = require('moment');

var DateTime = require('DateTime');
var Tooltip = require('../Tooltip');
var TemplateCache = require('TemplateCache');

var NightsCompressor = require('./NightsCompressor');
var ReservaTimeTableYearView = require('./ReservaTimeTableYearView');


var ReservaTimeTableYear = Backbone.Model.extend({

	defaults: function() {
		return {
			classes: [],
			start: null,
			container: null,
			viewData: null,
			cellWidth: null,
			titleWidth: 0,
			selectionData: null,
			filterClass: null,
		}
	},

	daysEncoding: {
		'.': -1, /* Empty display (not free) */
		'_': 0, /* Frei, aber kein Anreisetag */
		'1': 1,
		'2': 2,
		'3': 3,
		'4': 4,
		'5': 5,
		'6': 6,
		'7': 7,
		'8': 8,
		'9': 9,
		'A': 10,
		'B': 11,
		'C': 12,
		'D': 13,
		'E': 14,
		'F': 15,
		'G': 16,
		'H': 17,
		'I': 18,
		'J': 19,
		'K': 20,
		'L': 21,
	},

	initialize: function() {
		this.container = this.get("container");
		this.startDay = DateTime.resetTimeFields(moment((new Date).getFullYear() + "-01-01"));
		this.previousHoverData = { classOffset: null, dayOffset: null };

		this.tooltip = new Tooltip({
			className: 'reserva-timetable-tooltip',
			boxTransform: function(box) {
				/* Wir müssen die ersten 200px für die linken thead abschneiden */
				box.x1 += this.get("titleWidth");
				return box;
			}.bind(this),
		});

		this.view = new ReservaTimeTableYearView({
			el: this.container,
			model: this,
		});
		this.view.tooltip = this.tooltip;

		this.on('rendered', () => {
			this.tooltip.box = this.view.$el.find('tbody');
			this.tooltip.boxHasChanged();
		});

		this.on('change:filterClass', () => {
			this.set("viewData", {
				...this.get("viewData"),
				filterClass: this.get("filterClass"),
			})
			this.view.render();
		})
	},

	init: function() {
		this.tooltip.box = this.view.$el.find('tbody');
	},

	handleResponse: function(response) {
		this.startDay = DateTime.parse(response.start);

		this.dateCache = {};
		for(var i = 0; i <= 521; i++) {
			this.dateCache[i] = this.startDay.clone().add(i, 'days');
		}

		let mapping = this.daysEncoding;
		_.each(response.classes, function(klass) {
			klass.days_list = _.map(klass.days.split(''), (c) => mapping[c] );
		});

		let classes = [];
		let start = DateTime.parse(response.start);

		_.each(response.classes, (klass) => {
			let days_list = klass.days_list;
			let days = [];

			let maybePrevClass = '';
			let realPrevClass = '';

			let open = false; /* Sind wir in einem Gebiet mit freien Tagen? */
			let open2 = false; /* Sind wir in einem Gebiet mit freien Tagen, aber mit nicht-verfügbaren Anreisetagen? */
			let open3 = false; /* Sind wir in einem nicht-verfügbaren Gebiet, wo es kurz verfügbare Tage gibt? */
			_.each(days_list, function(day, i) {
				let date = this.dateCache[i];
				if ( !date ) {
					// In rare occasions we get more than 500 days from the API.
					date = this.startDay.clone().add(i, 'days');
					this.dateCache[i] = date;
				}

				let prevDay = i > 0 ? days_list[i - 1] : -1;
				let nextDay = i < days_list.length ? days_list[i + 1] : -1;

				let validArrival = day > 0;
				let isFree = day >= 0;

				let mainClass = '';

				/**
				 * Übersicht über die Klassen:
				 * [<] begin 	   Hellgrüner Start 
				 * [ ] free-avail  Hellgrün, kein Pfeil
				 * [ ] part2       Dunkelgrün, kein Pfeil
				 * [>] close2      Ende von hellgrünen Bereich in dunkelgrünen Bereich
				 * [<] begin2      Start in einem dunkelgrünem Bereich 
				 * [>] end         Ende in hellgrünem Bereich 
				 * [>] end2        Ende von dunkelgrünem Bereich 
				 * [o] begin3      Start von hellgrün und sofort dunkelgrün nächster Tag
				 * [o] begin4      Start von dunkelgrün und sofort dunkelgrün nächster Tag
				 */

				if ( open ) {
					/* Einfacher Fall: Tag ist verfügbar -> grün */
					if ( validArrival ) {
						mainClass = 'free-avail';
					}

					/* Falls wir offen sind, aber ab heute nicht mehr verfügbar sind: Farbe wechseln */
					if ( open3 && nextDay === 0 ) {
						mainClass = 'close2';
						open3 = false;
					}
					else if ( open2 ) {
						if ( validArrival ) {
							/* Anreisetag in sonst nicht-freier Zone */
							mainClass = 'begin2';
							open3 = true;
						} else {
							mainClass = 'part2';
						}
					}

					/* Wenn der nächste Tag kein gültiger Anreisetag - aber frei ist, wechseln wir die Farbe */
					if ( nextDay === 0 && !open2 ) {
						open2 = true;
						mainClass = 'close2';
					}

					/* Falls der Tag belegt ist, beenden wir diesen Block */
					if ( day === -1 ) {
						mainClass = open2 ? 'end2' : 'end2';
						open = false;
						open2 = false;
						open3 = false;
					}
				} else {
					if ( isFree && validArrival ) {
						/* Einzelner Anreisetag */
						if ( nextDay === 0 ) {
							mainClass = 'begin3';
							open = true;
							open2 = true;
						} else {
							/* Start einer Gruppe */
							mainClass = 'begin';
							open = true;
						}
					}
				}

				let helperClasses = [];
				if ( open ) helperClasses.push('open');
				if ( open2 ) helperClasses.push('open2');
				if ( open3 ) helperClasses.push('open3');
				if ( validArrival ) helperClasses.push('validArrival');

				/* Overrides to fix corner cases */
				let mainClassCopy = mainClass;

				// wenn [ ][ < ][ ] Zelle sollte [o] sein
				// hellgrüne Zelle zwischen dunkelgrün
				if ( realPrevClass === "begin2" && mainClass === "part2" ) {
					days[i - 1].className = "begin4";
				}

				if ( maybePrevClass === "begin2" && mainClass === "begin2" ) {
					mainClass = "free-avail";
				}

				if ( realPrevClass === "begin2" && mainClass === "close2" && day === 0 ) {
					mainClass = "part2";
					days[i - 1].className = "begin4";
				}

				if ( mainClassCopy === "end2" && days[i - 2] && days[i - 2].className != "begin3" ) {

					if ( realPrevClass === "free-avail" ) {
						days[i - 1].className = "close2";
					} else {
						if ( open2 || prevDay === 1 ) {

							days[i - 1].className = days[i - 2].className === ( "part2" || "begin3" ) ? "begin4" : "begin3";

						} else {
							days[i - 1].className = "part2";
						}
					}

				}

				maybePrevClass = mainClassCopy;
				realPrevClass = mainClass;

				if ( date.day() === 0 || date.day() === 6 ) {
					helperClasses.push("weekend");
				}

				let dayName = "";
				helperClasses.push("dayt_" + date.day());
				if ( date.day() === 0 ) {
					dayName = "Su";
					helperClasses.push("sunday");
				}
				if ( date.day() === 6 ) {
					dayName = "Sa";
					helperClasses.push("saturday");
				}

				if ( mainClass === "" ) {
					mainClass = "occupied";
				}

				days.push({
					index: i,
					day: day,
					date: date,
					prevDay: prevDay,
					nextDay: nextDay,
					className: mainClass,
					dayName: dayName,
					maybeClass: mainClassCopy,
					helperClasses: helperClasses.join(" "),
				});
			}.bind(this));

			classes.push({
				name: klass.name,
				info: klass.info,
				/* + 1, da wir im Template einen Tag in die Zukunft sehen */
				days: days,
			});
		}.bind(this));

		this.set({
			classes: classes,
			response: response,
			start: start,
			filterClass: classes[0].name,
		});

		this.set("viewData", {
			filterClass: this.get("filterClass"),
			monthNames: __('monthNamesShort') || [
				'Jan',
				'Feb',
				'Mär',
				'Apr',
				'Mai',
				'Jun',
				'Jul',
				'Aug',
				'Sep',
				'Okt',
				'Nov',
				'Dez',
			],
			monthDays: [
				31, ((new Date).getFullYear() % 4 == 0 ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
				31, (((new Date).getFullYear() + 1) % 4 == 0 ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
				31, (((new Date).getFullYear() + 2) % 4 == 0 ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
				31, (((new Date).getFullYear() + 3) % 4 == 0 ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
			],
			classes: classes,
			start: start,
		});
	},

	/**
	 * Handler für Events auf einzelne Zellen
	 *
	 * @param data {Object} Daten von der Zelle (classOffset, dayOffset)
	 * @param $e {jQuery} Ausgewählte Zelle
	 * @param action {String} Aktion (click, hover)
	 */
	cellAction: function(data, $e, action) {
		let days = this.get("classes")[data.classOffset].days;
		let day_data = days[data.dayOffset];
		let day = day_data.day;
		let text = "";

		if ( this.previousHoverData.classOffset === data.classOffset
		  && this.previousHoverData.dayOffset === data.dayOffset
		  && this.previousHoverAction == action ) {
			return;
		}

		this.previousHoverData = data;
		this.previousHoverAction = action;

		let dayOffset = data.dayOffset;
		let hoverDate = this.startDay.clone().add(dayOffset, 'days');

		let validArrival = day > 0;
		let isFree = day >= 0;

		let lines = [];

		let lookAhead = function(dayOffset, day) {
			let nextOffset = dayOffset + day;
			let lookAhead;
			let nextValidNights = [];
			while ( lookAhead = days[nextOffset] ) {

				nextValidNights.push(nextOffset - dayOffset);
				nextOffset++;
				if ( (nextOffset - dayOffset) > 21 ) break;
				if ( lookAhead.day === -1 ) break;
			}
			if ( nextValidNights.length === 0 && day > 0 ) return [day];
			return nextValidNights;
		}.bind(this);

		if ( !isFree ) {
			// Kein tooltip
		} else if ( !validArrival ) {
			lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));
			lines.push("Keine Anreise möglich");

		} else {
			lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));

			/* Nach vorne schauen und prüfen, an welchen Tagen wir noch anreisen könnten */
			let nextValidNights = lookAhead(dayOffset, day);
			let text = "Anreise möglich für " + NightsCompressor.humanString(nextValidNights);
			lines.push(text);
		}

		// Erstmal alle Selection-Klassen löschen
		this.view.$el.find('.selection').removeClass('selection select-start select-part select-end selection-valid selection-invalid');

		if ( action === "click" ) {

			let selectionData = this.get("selectionData");
			let select_start = true;

			if ( selectionData ) {
				/* Der User hat bereits geklickt und will seine Auswahl vollenden */
				select_start = false;

				/* Falls es die gleiche Klasse ist, nehmen wir die Auswahl an. Ansonsten wird eine neue gestartet. */
				if ( selectionData.classOffset === data.classOffset ) {
					let from = this.startDay.clone().add(selectionData.dayOffset, 'days');
					let to = this.startDay.clone().add(data.dayOffset, 'days');

					let nightsCount = data.dayOffset - selectionData.dayOffset;
					let valid = selectionData.lookAhead.indexOf(nightsCount) !== -1;
					if ( valid ) {
						console.log("Setting selection to", from.format("YYYY-MM-DD"), "=>", to.format("YYYY-MM-DD"));
						this.trigger("dateSelected", from, to);
						setTimeout(() => {
							this.tooltip.boxHasChanged();
						}, 3000);
						setTimeout(() => {
							this.tooltip.boxHasChanged();
						}, 9000);
					}

				} else {
					select_start = true;
				}
				this.set("selectionData", null);
			}

			if ( select_start ) {
				if ( day > 0 ) {
					data.lookAhead = lookAhead(dayOffset, day);
					data.tooltip = "Anreise möglich für " + NightsCompressor.humanString(data.lookAhead);
					data.startDay = hoverDate;
					this.set("selectionData", data);
				} else if ( day === -1 ) {
					lines = ["Unterkunft ist an diesem Tag bereits belegt."];
				}
			}
		}

		text = lines.join("<br>");

		let selectionData = this.get("selectionData");
		if ( selectionData && selectionData.classOffset === data.classOffset ) {
			let nightsCount = data.dayOffset - selectionData.dayOffset;
			nightsCount = Math.max(nightsCount,  0);

			let valid = selectionData.lookAhead.indexOf(nightsCount) !== -1;
			let validClass = 'selection-' + (valid ? 'valid' : 'invalid') + ' ';

			lines = [];
			lines.push('<span class="selection-info ' + validClass + '">');
			lines.push(DateTime.textPeriod(selectionData.startDay, hoverDate));
			lines.push('<br>');

			if ( nightsCount > 21 ) {
				lines.push("Mehr als 21 Nächte ausgewählt");
			} else if ( nightsCount === 0 ) {
				lines.push("Bitte Abreisetag auswählen");
			} else if ( !valid ) {
				lines.push(selectionData.tooltip);
			}
			lines.push('</span>')

			if ( selectionData.dayOffset === data.dayOffset ) {
				$e.addClass('selection ' + validClass + 'select-start');
			} else {
				for(var i = selectionData.dayOffset; i <= data.dayOffset; i++) {
					let klass = 'select-part';
					if ( i === selectionData.dayOffset ) klass = 'select-start';
					if ( i === data.dayOffset ) klass = 'select-end';

					this.view.$el.find('.cell_' + data.classOffset + '_' + i).addClass('selection ' + validClass + klass);
				}
			}

			text = lines.join("");
		}

		if ( lines.length === 0 ) {
			lines = ["Unterkunft ist an diesem Tag bereits belegt."];
			text = lines.join("");
		}

		if ( lines.length > 0 ) {
			if ( location.hostname === "localhost" || window.Tramino.user == 10 ) {
				text += "<br><i>index(" + day_data.index + ") prev(" + day_data.prevDay + ") day(" + day_data.day + ") next(" + day_data.nextDay + ") mainClass(" + day_data.className + ")<br>maybeClass(" + day_data.maybeClass + ") helperClasses(" + day_data.helperClasses + ")</i>";
			}

			this.tooltip.set(text);
		} else {
			this.tooltip.hide();
		}
	},

});

module.exports = ReservaTimeTableYear;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/miniengine/ReservaTimeTableYear.js
 **/